import Image from 'next/image';
import Link from 'next/link';
import React, { type FC, useMemo } from 'react';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
import { useCampaign } from '@/Module/DefaultLayout/Hook';
const HeaderDesktopBanner: FC = () => {
  const {
    desktopBanner
  } = useCampaign();
  const gradientStyle = useMemo(() => {
    return {
      backgroundImage: `linear-gradient(to right, ${desktopBanner?.from} 50%, ${desktopBanner?.via} 50%, ${desktopBanner?.to} 100%)`
    };
  }, [desktopBanner?.from, desktopBanner?.via, desktopBanner?.to]);
  return <div data-sentry-component="HeaderDesktopBanner" data-sentry-source-file="HeaderDesktopBanner.tsx">
      <Link target="_blank" href={desktopBanner?.ctaLink ?? ''} style={gradientStyle} className="flex items-center justify-center border-red-700" data-sentry-element="Link" data-sentry-source-file="HeaderDesktopBanner.tsx">
        <Image src={`${FILE_BROWSER_URL}/campaign/${desktopBanner?.image}`}
      // loading="lazy"
      priority id="campaignDesktop" alt={desktopBanner?.alt ?? 'campaign-desktop'} width={1080} height={60} quality={100} data-sentry-element="Image" data-sentry-source-file="HeaderDesktopBanner.tsx" />
      </Link>
    </div>;
};
export default React.memo(HeaderDesktopBanner);